import type { OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Subject } from 'rxjs';

import type { SelectedFileExtended } from '@common/types/file.type';

import { NgIf } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SpSetupImageDropdownComponent } from '../sp-setup-image-dropdown/sp-setup-image-dropdown.component';
import { SpFileManagerContextService } from '../sp-file-manager-context.service';

@Component({
    selector: 'sp-image-preview-single',
    templateUrl: './sp-image-preview-single.component.html',
    styleUrls: ['./sp-image-preview-single.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, BsDropdownModule, SpSetupImageDropdownComponent],
})
export class SpImagePreviewSingleComponent implements OnChanges {
    public readonly ctx = inject(SpFileManagerContextService);

    @Input() public file: SelectedFileExtended = null;
    @Input() public isLink: boolean;
    @Input() public showSetupBtn: boolean;
    @Input() public short: boolean = false;

    @Output() public updateFileEvent: EventEmitter<SelectedFileExtended> = new EventEmitter<SelectedFileExtended>();
    @Output() public removeFileEvent: EventEmitter<any> = new EventEmitter();
    @Output() public replaceFileEvent: EventEmitter<any> = new EventEmitter();
    @Output() public imageEditEvent: EventEmitter<void> = new EventEmitter<void>();

    public readonly closeSubject: Subject<void> = new Subject<void>();

    private imagePreviewIndex = 0;
    private imagePreviewSourceKey = '';

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.file) {
            this.imagePreviewIndex = 0;
        }
    }

    public get imagePreviewSrc(): string {
        const sources = this.ctx.buildFilePreviewUrls(this.file);
        this.resetImagePreviewIndexOnSourcesChange(sources);

        return sources[this.imagePreviewIndex] || sources[0] || '';
    }

    public showNextImagePreview(): void {
        const sources = this.ctx.buildFilePreviewUrls(this.file);
        this.resetImagePreviewIndexOnSourcesChange(sources);

        if (this.imagePreviewIndex < sources.length - 1) {
            this.imagePreviewIndex += 1;
        }
    }

    private resetImagePreviewIndexOnSourcesChange(sources: string[]): void {
        const sourceKey = sources.join('\n');

        if (this.imagePreviewSourceKey === sourceKey) {
            return;
        }

        this.imagePreviewSourceKey = sourceKey;
        this.imagePreviewIndex = 0;
    }

    public saveSetupData(file: SelectedFileExtended): void {
        this.updateFileEvent.emit({ ...this.file, ...file });
    }

    public emitHiddenEventToChild(): void {
        this.closeSubject.next();
    }
}
